<template>
  <div class="wrap">
    <slot name="content" />

    <div class="app-footer">
      <button
        v-if="pwaState === 'update-ready'"
        class="app-footer__pwa-action"
        type="button"
        @click="applyPwaUpdate"
      >
        Доступно обновление приложения
      </button>
      <span v-else-if="pwaState === 'offline-ready'" class="app-footer__pwa-status">
        Офлайн-режим готов
      </span>
      <RouterLink
        v-if="showPolicyLink"
        class="app-footer__policy-link"
        to="/policy"
      >
        Политика конфиденциальности
      </RouterLink>
      <!-- <div class="app-version">
        {{ versionInfo.formatted }}
      </div> -->
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed, onMounted, onUnmounted, ref } from "vue";
import { useRoute } from "vue-router";
import { isTelegramSession } from "@/shared/lib/telegram/runtime";

const route = useRoute();
const pwaState = ref<'idle' | 'offline-ready' | 'update-ready'>('idle')

const showPolicyLink = computed(() => {
  const isHomeRoute = route.name === "home";
  return !isTelegramSession() && isHomeRoute;
});

const onPwaOfflineReady = () => {
  pwaState.value = 'offline-ready'
}

const onPwaUpdateReady = () => {
  pwaState.value = 'update-ready'
}

const applyPwaUpdate = () => {
  window.dispatchEvent(new CustomEvent('pwa:apply-update'))
}

onMounted(() => {
  window.addEventListener('pwa:offline-ready', onPwaOfflineReady)
  window.addEventListener('pwa:update-ready', onPwaUpdateReady)
})

onUnmounted(() => {
  window.removeEventListener('pwa:offline-ready', onPwaOfflineReady)
  window.removeEventListener('pwa:update-ready', onPwaUpdateReady)
})
</script>

<style lang="scss">
.wrap {
  background: $secondary-gradient;
  max-width: 100%;
  width: 100%;
  padding: 20px;
  height: var(--tg-viewport-height, var(--app-viewport-height, 100dvh));
  margin: 0 auto;
  color: $neutral-100;
  position: relative;
  box-sizing: border-box;
  overflow-x: hidden;
  overflow-y: hidden;
  display: flex;
  flex-direction: column;
  // Учитываем безопасную область Telegram/OS, чтобы контент не уходил под нижнюю панель
  padding-bottom: calc(
    20px + var(--tg-safe-area-inset-bottom, 0px) +
      env(safe-area-inset-bottom, 0px)
  );
}

.app-footer {
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding-bottom: 15px;
}

.app-footer__policy-link {
  @include p3-regular;
  font-size: 11px;
  color: rgba(255, 255, 255, 0.75);
  text-decoration: underline;
  text-decoration-thickness: 1px;
  text-underline-offset: 2px;
}

.app-footer__pwa-action {
  @include p3-regular;
  border: 0;
  background: transparent;
  color: rgba(255, 255, 255, 0.85);
  text-decoration: underline;
  text-underline-offset: 2px;
  padding: 0;
  cursor: pointer;
}

.app-footer__pwa-status {
  @include p3-regular;
  font-size: 11px;
  color: rgba(255, 255, 255, 0.75);
}

.app-version {
  color: rgba(255, 255, 255, 0.5);
  font-size: 12px;
  pointer-events: none;
}
</style>
